/* tslint:disable */
/* eslint-disable */
/**
 * ファイル管理ポータル クライアントAPI
 * ファイル管理ポータル Webクライアント向けAPI 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: TODO@graat.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ファイル情報
 * @export
 * @interface FileInfoModel
 */
export interface FileInfoModel {
    /**
     * ファイルID
     * @type {string}
     * @memberof FileInfoModel
     */
    'file_id': string;
    /**
     * ファイルセキュリティ区分 - ORIGINAL:01)オリジナル(パスワード無しx印刷可) - PASSWORD_PRINT_AVAILABLE:02)パスワード有りx印刷可 - PASSWORD_PRINT_UNAVAILABLE:03)パスワード有りx印刷不可 
     * @type {string}
     * @memberof FileInfoModel
     */
    'file_security_type': FileInfoModelFileSecurityTypeEnum;
}

export const FileInfoModelFileSecurityTypeEnum = {
    Original: 'ORIGINAL',
    PasswordPrintAvailable: 'PASSWORD_PRINT_AVAILABLE',
    PasswordPrintUnavailable: 'PASSWORD_PRINT_UNAVAILABLE'
} as const;

export type FileInfoModelFileSecurityTypeEnum = typeof FileInfoModelFileSecurityTypeEnum[keyof typeof FileInfoModelFileSecurityTypeEnum];


